import { render, staticRenderFns } from "./Style2.vue?vue&type=template&id=63757f89"
import script from "./Style2.vue?vue&type=script&lang=js"
export * from "./Style2.vue?vue&type=script&lang=js"
import style0 from "./Style2.vue?vue&type=style&index=0&id=63757f89&prod&lang=css"
import style1 from "./Style2.vue?vue&type=style&index=1&id=63757f89&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports